import type { EditorState } from '@tiptap/pm/state';

/**
 * Returns `true` if node with the provided id is within the current selection range.
 */
export const isNodeSelected = (state: EditorState, nodeId: string) => {
  let selected = false;

  state.doc.nodesBetween(state.selection.from, state.selection.to, node => {
    if (node.attrs.id === nodeId) {
      selected = true;
    }

    return !selected;
  });

  return selected;
};
